import PropTypes from 'prop-types';
import useAuth from '../../../hooks/useAuth';
import AuthorizationError from '../../../pages/error/AuthorizationError';
// import { Divisions } from '../../../utils/constants/Divisions.Constants';

const PermissionGaurd = (props) => {
  const { permission, right, children } = props;
  const { isAuthorized } = useAuth();
  // const { isAuthorizedPetrohub } = useAuth();
  const { assignedDivisions } = useAuth();
  console.log('Assigned Divisions in PermissionGuard: ', assignedDivisions);
  // const hasMaxLIMSAccess = assignedDivisions.includes(Divisions.MaxxLIMs);
  const isAllowed = isAuthorized({ permissionCode: permission, right });
  // console.log(isAllowed ? `User is authorized for permission: ${permission}` : `User is not authorized for permission: ${permission}`);
  // const isAllowed = hasMaxLIMSAccess ? isAuthorizedPetrohub({ permissionCode: permission, right }) : isAuthorized({ permissionCode: permission, right });

  if (!isAllowed) {
    return <AuthorizationError />;
  }

  return <>{children}</>;
};

export const PermissionRights = {
  Search: 'S',
  Add: 'I',
  Edit: 'M',
  Approve: 'A',
  Export: 'E',
  Delete: 'D',
};

export const PermissionCodes = {
  Client: 'client',
  Cylinder: 'cylinder',
  Order: 'order',
  Action: 'Action',
  Email: 'Email',
  MyActions: 'MyActions',
  Cycle: 'Cycle',
  NAList: 'NAList',
  Enrollment: 'Enrollment',
  Program: 'Program',
  List: 'List',
  Dashboard: 'Dashboard',
  Organization: 'Organization',
  Audit: 'Audit',
  TestMethod: 'TestMethod',
  Location: 'Location',
  Product: 'Product',
  Country: 'Country',
  Unit: 'Unit',
  IgnoreList: 'IgnoreList',
  Region: 'Region',
  Contact: 'Contact',
  Role: 'Role',
  SubjectMatterExpertise: 'SubjectMatterExpertise',
  User: 'User',
  Announcement: 'Announcement',
  Group: 'Group',
  AccreditationBody: 'AccreditationBody',
  MyAnnouncement: 'MyAnnouncement',
  MethodEquivalence: 'MethodEquivalence',
  LabSummaryReport: 'LabSummaryReport',
  OutstandingCARsReport: 'OutstandingCARsReport',
  TrendingGraphReport: 'TrendingGraphReport',
  CompanySummaryReport: 'CompanySummaryReport',
  DataExport: 'DataExport',
  ReportGrading: 'ReportGrading',
  ZCarPercentageReport: 'ZCarPercentageReport',
  Sample: 'Sample',
  CycleNAList: 'CycleNAList',
  CycleEnrollment: 'CycleEnrollment',
  SampleEnrollment: 'SampleEnrollment',
  ResultEntry: 'ResultEntry',
  StatsEntry: 'StatsEntry',
  AutoImportData: 'AutoImportData',
  SampleReview: 'SampleReview',
  Asset: 'Asset',
  RunSumReport: 'RunSumReport',
  SubcontractingLocation: 'SubcontractingLocation',
};

export const CustomPermissions = {
  CanFinalizeSample: 'CanFinalizeSample',
  CanCancelCycle: 'CanCancelCycle',
  CanExportToXlsx: 'CanExportToXlsx',
};

PermissionGaurd.propTypes = {
  permission: PropTypes.string.isRequired,
  right: PropTypes.string,
  children: PropTypes.node,
};

export default PermissionGaurd;
